import { UserAgentApplication, Configuration, AuthenticationParameters } from 'msal';

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.NEXT_PUBLIC_AD_CLIENT_KEY as string,
        authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_AD_AUTHORITY}`,
        redirectUri: process.env.NEXT_PUBLIC_AD_REDIRECT,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    }
};

let msalInstance: UserAgentApplication | null = null;

if (typeof window !== 'undefined') {
    msalInstance = new UserAgentApplication(msalConfig);
}

export async function getAccessTokenForGraph() {
    const request: AuthenticationParameters = {
        scopes: ["User.ReadBasic.All"]
    };

    try {
        const response = await msalInstance?.acquireTokenSilent(request);
        return response?.accessToken;
    } catch (error) {
        const response = await msalInstance?.acquireTokenPopup(request);
        return response?.accessToken;
    }
}

export { msalInstance };